import { useMemo } from 'react';
import { membershipsSelector } from 'slices/memberships.slice';
import { selectObjectTypesMap } from 'slices/objectTypes.slice';
import { useAppSelector } from 'slices/store';
import { getMemberTypes } from 'utils/associations';
import type { TType } from '@timeedit/types';
import type { FormInstance } from '@timeedit/ui-components/antd';
import BulkEditAssociation from './BulkEditAssociation';
import type { BulkEditAction } from './common';

type Props = {
  action: BulkEditAction;
  form: FormInstance;
  objectType: TType;
};

const BulkEditMembers = ({ action, form, objectType }: Props) => {
  const memberships = useAppSelector(membershipsSelector);
  const objectTypesMap = useAppSelector(selectObjectTypesMap);

  const objectTypes = useMemo(
    () => getMemberTypes([objectType?.id], memberships, objectTypesMap),
    [objectType, memberships, objectTypesMap]
  );

  return (
    <BulkEditAssociation
      action={action}
      form={form}
      objectTypes={objectTypes}
      relationType="members"
    />
  );
};

export default BulkEditMembers;
